import { ConfigProvider, Spin } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { Dispatch, SetStateAction } from 'react';

import { LightTable, TableWrapper } from '../../../../../../components/index';
import { CeMerchantGroupbyNcmItemType } from '../../../../../../types';

type AssociateLoadingTableProps = {
  columns: (
    onSelectItem: any,
    selectedItemIds: number[],
    onToggleItem: (record: Record<string, any>) => void,
    headerChecked: boolean,
    headerIndeterminate: boolean,
    onToggleHeader: () => void,
    isVehicleManifest: boolean,
    selectedOpDirectionManifest: string,
    hasVolume: boolean,
    isTogglingAll: boolean
  ) => ColumnsType<Record<string, any>>;
  dataSource: Record<string, any>[];
  total?: number;
  itemsPerPage?: number;
  isLoading?: boolean;
  pageSize?: number;
  showSizeChanger?: boolean;
  rowKey?: string;
  onSelectItem?: (record: any) => void;
  onChangePagination?: (page: number) => number;
  queryPage: number;
  rowSelection?: any; // tive que manter any, O tipo correto seria TableRowSelection<object> mas o esLint reclama de usar object como type e se tentar passar Record<string, any> não funciona pq não é object
  selectedItems: CeMerchantGroupbyNcmItemType[];
  setSelectedItems: Dispatch<SetStateAction<CeMerchantGroupbyNcmItemType[]>>;
  // Disparado quando o usuário marca/desmarca uma carga individual, para desfazer
  // o modo "todas as cargas selecionadas".
  onUserToggle?: () => void;
  // Estado do checkbox do cabeçalho, que marca/desmarca TODAS as cargas do filtro.
  headerChecked: boolean;
  headerIndeterminate: boolean;
  onToggleHeader: () => void;
  // Carregando a seleção de "todas" (busca em todas as páginas).
  isTogglingAll: boolean;
  isVehicleManifest: boolean;
  selectedOpDirectionManifest: string;
  hasVolume: boolean;
};

export function AssociateLoadingTable(props: AssociateLoadingTableProps) {
  const {
    columns,
    dataSource,
    total,
    itemsPerPage,
    onChangePagination,
    isLoading,
    pageSize,
    showSizeChanger,
    onSelectItem,
    rowKey,
    queryPage,
    rowSelection,
    selectedItems,
    setSelectedItems,
    onUserToggle,
    headerChecked,
    headerIndeterminate,
    onToggleHeader,
    isTogglingAll,
    isVehicleManifest,
    selectedOpDirectionManifest,
    hasVolume,
  } = props;

  const selectedItemIds = selectedItems.map(
    (item) => item.ncm_item_id as number
  );

  function onToggleItem(record: Record<string, any>) {
    onUserToggle?.();
    const id = record.ncm_item_id as number;
    setSelectedItems((prev) =>
      prev.some((item) => item.ncm_item_id === id)
        ? prev.filter((item) => item.ncm_item_id !== id)
        : [...prev, record as CeMerchantGroupbyNcmItemType]
    );
  }

  function customizeRenderEmpty() {
    return <>Não há dados cadastrados.</>;
  }
  return (
    <Spin spinning={isLoading} tip="Carregando...">
      <TableWrapper>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <LightTable
            rowKey={rowKey || 'key'}
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: itemsPerPage,
              pageSize,
              total,
              onChange: onChangePagination,
              showSizeChanger,
              current: queryPage,
            }}
            columns={columns(
              onSelectItem,
              selectedItemIds,
              onToggleItem,
              headerChecked,
              headerIndeterminate,
              onToggleHeader,
              isVehicleManifest,
              selectedOpDirectionManifest,
              hasVolume,
              isTogglingAll
            )}
            dataSource={dataSource}
            rowSelection={rowSelection}
          />
        </ConfigProvider>
      </TableWrapper>
    </Spin>
  );
}
